import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'summary-preloader',
  setup(__props) {

const queryParams = window.location.search;
const isSingleItem = computed(() => {
  const hasQueryParams = queryParams ? true : false
  const isModifyCheckout = window.location.pathname.includes('modify-checkout');
  const isCancelItem = window.location.pathname.includes('cancel');

  return hasQueryParams && !isModifyCheckout && !isCancelItem;
})


return { __sfc: true,queryParams, isSingleItem }
}

})